import { styled } from "styled-components";

export const NovoUsuarioContainer = styled.div`
  width: calc(100% - 260px);
  display: flex;
  justify-content: center;
  border-radius: 40px;
  height: 100vh;

  .box {
    width: 100%;
    min-height: 300px;
    border-radius: 30px 0px 0px 30px;
    padding: 40px;
    background-color: var(--base01);
    overflow-y: auto;

    .voltar {
      svg {
        width: 45px;
        height: 45px;
        cursor: pointer;
      }
    }

    h1 {
      font-size: 50px;
      font-weight: 600;
      margin-left: 10px;
      margin-bottom: 16px;
      color: var(--principal);
    }

    h2{
      font-size: 24px;
      font-weight: 600;
      margin-top: 40px;
      color: var(--principal);
    }

    .tituloRemover{
        color: black;
        margin-bottom: 30px;
        line-height: 1.2;
    }

    .div-pontos{
      width: 100px;

      > label {
        margin-bottom: 10px;
        font-size: 0.8rem;
      }

      > input {
        border: none;
        background-color: var(--base);
        padding: 10px;
        border-radius: 6px;
        font-size: 0.8rem;
        outline: none;
      }
    }

    .underline {
      font-size: 14px;
      margin-left: 10px;
      color: var(--principal);
    }

    .buttons {
      margin-top: 5px;
      display: flex;
      align-items: center;
      gap: 20px;
      
      a {
        font-size: 0.9rem;
      }
      
      span, button {
        display: flex;
        justify-content: center;
        background-color: var(--amarelo);
        color: var(--principal);
        border: none;
        padding: 5px;
        border-radius: 20px;
        width: 10%;
        font-size: 0.8rem;
        font-weight: 600;
        cursor: pointer;
      }

      .sim{
        width: 100px;
        height: 60px;
        background-color: #28a745;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
      }
      
      .nao{
        width: 100px;
        height: 60px;
        background-color: #dc3545;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 28px;
      }

      .finalizar{
        background-color: var(--base01);
        border: 1px solid var(--principal);
        width: 150px;
      }
    }

    .titulo2{
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .div-finalizada{
    width: 100%;
    border: solid 1px #413B3B;
    border-radius: 6px;
    height: 100px;
    margin-top: 20px;
    margin-bottom: 20px;
    display: flex;
    align-items: baseline;
    gap: 20px;
  }

  .status-finalizado{
    padding: 5px 10px;
    background-color: #413B3B;
    border-radius: 100px;
    width: 200px;
    height: max-content;
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-left: 30px;

    span{
      color: white;
      font-weight: 500;
    }

  }

  .info-pedido{
    font-weight: 600;
    margin-bottom: 5px;
  }

  .justificativa{
    color: #6E6E6E;
    font-size: 12px;
  }
  
  .label-file{
    padding: 10px;
    border: 2px dashed #878282; 
    border-radius: 5px;
    background-color: white;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px auto;
    width: 100%;
    color: var(--principal);
    text-decoration: underline;
  }

  .div-files{
    display: flex;
    gap: 40px;
    width: 100%;
    flex-wrap: wrap;
  }

  .relative-file{
    position: relative;
    
    span{
      position: absolute;
      top: -10px;
      right: -15px;
      cursor: pointer;
      color: red;
      font-size: 20px;
      font-weight: 700;
    }
  }

  .titulo{
    display: flex;
    align-items: baseline;

    svg{
      width: 45px;
      height: 45px;
      margin-left: 10px;
    }
  }

  .prazo{
    width: 300px;
  }
`;

export const Body = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 10px;

  .checkbox input {
    display: none;
  }

  .checkbox input + label:before {
    content: "";
    width: 15px;
    height: 15px;
    border-radius: 2px;
    border: 1px solid #979696;
    vertical-align: middle;
    display: inline-block;
    margin-left: 5px;
    margin-right: 5px;
    cursor: pointer;
  }

  .checkbox input:checked + label:before {
    background-image: url("data:image/svg+xml,%0A%3Csvg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 10 10'%3E%3Cg class='nc-icon-wrapper' stroke-width='1' fill='%23555555'%3E%3Cpath fill='none' stroke='%23FFFFFF' stroke-linecap='round' stroke-linejoin='round' stroke-miterlimit='10' data-cap='butt' d='M2.83 4.72l1.58 1.58 2.83-2.83'/%3E%3C/g%3E%3C/svg%3E");
    background-color: var(--amarelo);
  }

  .checkbox label {
    font-size: 0.9rem;
  }

  h2 {
    margin: 20px 0px 30px 0px;
  }

  > label {
    margin-bottom: 10px;
    font-size: 0.8rem;
  }

  > input {
    border: none;
    background-color: var(--base);
    padding: 10px;
    border-radius: 6px;
    font-size: 0.8rem;
    outline: none;
  }
`;

export const ContainerInputs = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 20px 0 10px 0;
  gap: 50px;

  > div {
    display: flex;
    flex-direction: column;
    width: 100%;

    > label {
      margin-bottom: 10px;
      font-size: 0.9rem;
      font-weight: 500;
    }

    > 
    input,
    select,
    textarea {
      border: none;
      background-color: var(--base);
      padding: 10px;
      border-radius: 6px;
      font-size: 0.8rem;
      outline: none;
    }

    textarea{
      max-width: 100%;
      min-width: 100%;
      max-height: 400px;
      min-height: 80px;
    }
  }
`;
